import { Component, HostListener } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardPageLayout } from '../../stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-common-custom-confirm-dialog',
	templateUrl: './common-custom-confirm.dialog.component.html',
	providers: [DialogService],
})

export class CommonCustomConfirmDialogComponent {
	row1: string = '';
	row2: string = '';

	classAcceptButton: string = 'p-button-warning';
	classRejectButton: string = 'p-button-secondary';

	labelAcceptButton: string = 'CONFIRM';
	labelRejectButton: string = 'CANCEL';

	visibleAcceptButton: boolean = true;
	visibleRejectButton: boolean = true;

	icon: string = 'pi cm-info';

	// design
	screenWidth: number;

	constructor(
		public dialogService: DialogService,
		private refDialog: DynamicDialogRef,
		public config: DynamicDialogConfig,
	){
		if (config.data) {
			if (config.data.row1) {
				this.row1 = config.data.row1;
			}
			if (config.data.row2) {
				this.row2 = config.data.row2;
			}
			if (config.data.icon) {
				this.icon = config.data.icon;
			}
			if (config.data.classAcceptButton) {
				this.classAcceptButton = config.data.classAcceptButton;
			}
			if (config.data.classRejectButton) {
				this.classRejectButton = config.data.classRejectButton;
			}
			if (config.data.labelAcceptButton) {
				this.labelAcceptButton = config.data.labelAcceptButton;
			}
			if (config.data.labelRejectButton) {
				this.labelRejectButton = config.data.labelRejectButton;
			}
			if (config.data.visibleAcceptButton === false) { // is just true
				this.visibleAcceptButton = config.data.visibleAcceptButton;
			}
			if (config.data.visibleRejectButton === false) { // is just true
				this.visibleRejectButton = config.data.visibleRejectButton;
			}
		}
	}

	submit(): void {
		this.refDialog.close(true);
	}

	closeDialog(): void {
		this.refDialog.close(false);
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

}
